import { rankWith, uiTypeIs } from "@jsonforms/core";

const EmptyRenderer = () => null;

export const EmptyTester = rankWith(
  100,
  uiTypeIs("Empty")
);

export default EmptyRenderer;
